module.exports = __webpack_public_path__ + "static/media/mastercard.964dc8a0.svg";